/* Complimentary sample picker — adds/removes the sample product, re-renders
   the cart drawer / cart page sections the same way the theme does, then
   re-inits FSProgressBar via the shopify:section:load listener in theme.js. */
(function () {
  var DRAWER = {
    section: 'cart-drawer',
    root: 'cart-drawer',
    selectors: [
      '.drawer__header-cart',
      '.free-shipping-bar',
      '.cart-drawer__form',
      '.drawer__footer-bottom-total',
    ],
  };

  function pageSection() {
    var el = document.querySelector('.main-cart-items');
    var wrap = el && el.closest('.shopify-section');
    if (!wrap || !wrap.id) return null;
    return {
      section: wrap.id.replace('shopify-section-', ''),
      root: '#' + wrap.id,
      selectors: [
        '.main-cart-items',
        '.free-shipping-bar',
        '.cart-info .totals',
        '.cart-recommendations',
      ],
    };
  }

  function targets() {
    var t = [DRAWER];
    var p = pageSection();
    if (p) t.push(p);
    return t;
  }

  function applySections(sections) {
    if (!sections) return;
    targets().forEach(function (t) {
      var html = sections[t.section];
      var root = document.querySelector(t.root);
      if (!html || !root) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      t.selectors.forEach(function (sel) {
        var src = doc.querySelector(sel);
        var dst = root.querySelector(sel);
        if (src && dst) dst.innerHTML = src.innerHTML;
      });
    });
    var bubble = sections['cart-icon-bubble'];
    if (bubble) {
      var el = document.getElementById('cart-icon-bubble');
      if (el) {
        var bdoc = new DOMParser().parseFromString(bubble, 'text/html');
        var inner = bdoc.querySelector('.shopify-section') || bdoc.body;
        el.innerHTML = inner.innerHTML;
      }
    }
    /* theme.js re-instantiates FSProgressBar on this event */
    document.dispatchEvent(new Event('shopify:section:load'));
  }

  function postCart(url, payload, done) {
    payload.sections = targets().map(function (t) { return t.section; }).concat(['cart-icon-bubble']);
    payload.sections_url = window.location.pathname;
    window.__skProgrammaticAdd = true; /* 2026-08-26: tell ad-tracking interceptors this is not a buyer add */
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .finally(function () { window.__skProgrammaticAdd = false; })
      .then(function (r) { return r.json(); })
      .then(function (d) { applySections(d.sections); })
      .catch(function () {})
      .finally(function () { if (done) done(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sample-add]');
    if (!btn) return;
    e.preventDefault();
    var picker = btn.closest('[data-sample-picker]');
    var sel = picker && picker.querySelector('[data-sample-variant]');
    if (!sel || !sel.value || btn.hasAttribute('aria-busy')) return;
    btn.setAttribute('aria-busy', 'true');
    postCart('/cart/add.js', { id: Number(sel.value), quantity: 1 }, function () {
      btn.removeAttribute('aria-busy');
    });
  });

  /* If the cart drops below the threshold while a sample is in it,
     the snippet renders a marker and we quietly remove the sample. */
  var removing = false;
  var observer = new MutationObserver(function () {
    if (removing) return;
    var marker = document.querySelector('[data-sample-auto-remove]');
    if (!marker) return;
    removing = true;
    postCart('/cart/change.js', {
      line: Number(marker.getAttribute('data-sample-auto-remove')),
      quantity: 0,
    }, function () { removing = false; });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
